module.exports = __webpack_public_path__ + "static/media/YM70_2.f14ebb20.jpg";